import type { FaireProductEntity } from "../../entity_types/product";

export const p_5da7gzv6mv: FaireProductEntity = {
  token: "p_5da7gzv6mv",
  type: "product",
  name: "Pink garden knotted gown and matching headband",
  brandToken: "b_mhuepp5kwa",
  brandName: "Baby in Styles",
  imageUrl:
    "https://cdn.faire.com/fastly/4f76b9d451f79682dd1ce21a05f64d63570324af83b0dc9d9df5fa50798aa513.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6e4037a10567f735e4ba995732c2bb82f4f04cb55f8998929686257d53c74a07.png",
  ],
  priceDollars: 16.5,
  description:
    "Our Newborn Knotted Baby Gown and Bow Sets are made of a buttery soft Rayon/Spandex blend. The ultra-soft baby gown features built-in no-scratch mittens to protect your baby’s delicate face from fingernail scratches. The working buttons allow you to easily pull the gown over your baby’s head and the knotted bottom of the gown makes diaper changes super easy! This set is ideal for ages newborn to 3 months old.",
  tags: [],
  msrpDollars: 33,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:20.337Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
